import { useState } from 'react'
import { IProjectCheckpointArtifact } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import Button from 'shared/Buttons/Button/Button'
import TextField from 'shared/Forms/TextField'
import FileInput from 'shared/Inputs/FileInput'
import Textarea from 'shared/Inputs/Textarea'
import Modal from 'shared/Modal'
import ModalHeader from 'shared/Modal/ModalHeader'
import Tag from 'shared/Tag'
import css from './appealModal.module.css'
import eventBus from 'services/eventBus'

type IProps = {
  onClose: () => void
  artifacts: IProjectCheckpointArtifact[]
}

export default function AppealModal(props: IProps) {
  const [comment, setComment] = useState<string>('')
  const [file, setFile] = useState<File | null>(null)

  const handleCommentChange = (val: string) => {
    setComment(val)
  }

  const handleFileChange = (_: string, selectedFile: File) => {
    setFile(selectedFile)
  }

  const handleDeleteFile = () => {
    setFile(null)
  }

  const handleCreateAppeal = async () => {
    if (!comment) {
      eventBus.pub('ntf.message', { type: 'error', message: 'Комментарий не заполнен' })
      return
    }
  }

  return (
    <Modal onClose={props.onClose} size='md' shouldAnimate={false}>
      <ModalHeader onClose={props.onClose}>Апелляция</ModalHeader>
      <div className={`modal-content flex-lines ${css.content}`}>
        <TextField header='Комментарий'>
          <Textarea
            value={comment}
            name='appealComment'
            onChange={handleCommentChange}
            placeholder='Опишите причину апелляцию'
            required={false}
            className={css.textarea}
            height='90px'
          />
        </TextField>

        <TextField header='Файл*'>
          <div className={css.fileRow}>
            <FileInput
              accept='application/pdf,image/png,image/jpeg'
              buttonClass='grey-outline'
              onChange={handleFileChange}
            >
              Загрузить
            </FileInput>
            <p className='text--body-m text--secondary'>ZIP, DOCS, PDF до 10 МБ.</p>
          </div>
          {file && (
            <div className={css.tags}>
              <Tag key={file.name} label={file.name} onDelete={handleDeleteFile} />
            </div>
          )}
        </TextField>
      </div>
      <div className={`${css.footer}`}>
        <div className={`inline-flex-gap ${css.footerActions}`}>
          <Button theme='primary' className={css.button} onClick={handleCreateAppeal}>
            Подать апелляцию
          </Button>
          <Button theme='grey-outline' className={css.button} onClick={props.onClose}>
            Отмена
          </Button>
        </div>
      </div>
    </Modal>
  )
}
